<template>
  <div>
    <b-carousel pause-text="" :autoplay="false">
      <b-carousel-item v-for="(widget, index) in chartWidgets" :key="index">
        <card :widget-model="widget" maintain-aspect-ratio :has-subtitle="false"></card>
      </b-carousel-item>
    </b-carousel>
  </div>
</template>

<script>
import to from "@/lib/to";
import WidgetModel from "@/models/WidgetModel";
import Card from "@/components/card/Card.vue";

export default {
  name: "QuickviewBlocksCarousel",
  components: {Card},
  props: ['monitor'],
  async mounted() {
    const cardModel = new WidgetModel('patient-card', {}, { retrievePatientInfo: false })
    cardModel.id = Math.random()
    cardModel.monitorId = this.monitor.id
    cardModel.patientId = this.monitor.patient.id
    cardModel.monitor = this.monitor
    this.chartWidgets.push(cardModel)

    const [err, response] = await to(this.$http.get(`/patient_monitors/${this.monitor.id}/available_charts`))
    if (!err) {
      const availableCharts = response.data
      availableCharts.forEach(chart => {
        const model = new WidgetModel(`${chart.type}-chart`, {chartId: chart.uid}, { retrievePatientInfo: false })
        model.id = Math.random()
        model.monitorId = this.monitor.id
        model.patientId = this.monitor.patient.id
        model.monitor = this.monitor
        this.chartWidgets.push(model)
      })
    }
  },
  data() {
    return {
      availableCharts: [],
      chartWidgets: []
    }
  }
}
</script>

<style scoped lang="scss">
:deep() {
  .carousel-indicator {
    bottom: -23px !important;
  }
  .carousel-arrow .icon {
    background: #2d7bff;
    color: #fff;
  }
  .carousel-items {
    border-radius: 4px;
    .monitoring-card {
      border-radius: 0;
    }
  }
  .has-icons-left {
    left: 0 !important;
  }
  .has-icons-right {
    right: 0 !important;
  }
}
</style>